export default __webpack_public_path__ + "assets/img/img-icon-credit@2x.131980309a36a5f4ca734f70f1e7ce20.png";